import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const ExpandIcon = (props: SvgIconProps) => (
  <ExpandMoreIcon {...props} style={{ padding: "none" }} />
);

export default ExpandIcon;
